import React from 'react';
import { PageTitle } from '../../../shared/components/ui/PageTitle';
import { InfoBanner } from '../../../shared/components/ui/InfoBanner';

const CustomerEFileEServe: React.FC = () => {
  return (
    <div>
      <PageTitle subtitle="Electronic filing and service combined">eFile/eServe</PageTitle>
      <InfoBanner>Combined eFile and eServe workflow coming soon.</InfoBanner>
    </div>
  );
};

export default CustomerEFileEServe;
